/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const logger = require('@gral/log');
const k = require('@gral/constants');
const act = require('../actions/actDispatcher');
const Action = require('../actions/action');

const log = logger('ACT: STORE');

const _relayNewAction = (type, data) => act.relay(new Action({ type, data, source: k.actionSources.VIEW }));

module.exports = {
  goTo(routePath, options) {
    if (options == null) {
      options = {};
    }
    log.info(`Automatically navigating to ${routePath}...`);
    return _relayNewAction('GO_TO', { routePath, fReplace: options.fReplace });
  },
  notify(notifPars) {
    log.info(`Automatically showing notification: ${notifPars.msg}...`);
    return _relayNewAction('NOTIF_SHOW', notifPars);
  },
  notifDismiss(cid) {
    log.info(`Automatically dismissing notification ${cid}...`);
    return _relayNewAction('NOTIF_DISMISS', cid);
  },
  changeLng(lng) {
    log.info(`Changing language to ${lng}...`);
    return _relayNewAction('CHANGE_LANGUAGE', { lng });
  },
  setCurrentLng(lng) {
    log.info(`Setting current language to ${lng}...`);
    return _relayNewAction('SET_CURRENT_LANGUAGE', { lng });
  },
  setActionTableV3(action) {
    log.info(`Set action table ${action.action}...`);
    return _relayNewAction('SET_ACTION_TABLE', { ...action });
  },
  loginAuto() {
    return _relayNewAction('LOGIN_AUTO');
  },
};
